// En la ficha de un equipo: si es un combo (kit) y sus tarifas por duración.
import { el } from '../../utils/dom.js';
import { Rentals, Items } from '../../api/resources.js';
import { fmtMoney } from '../../utils/format.js';
import { ok, err } from '../../components/toast.js';

export async function alquilerCard(item, recargar) {
  let datos;
  try { datos = await Rentals.alquilerEquipo(item.id); } catch { return null; }
  const card = el('div', { class: 'card mb-4' }, el('div', { class: 'card-head' }, el('h3', {}, 'Alquiler')));

  // Tarifas por duración
  const filas = el('div', { class: 'flex-col gap-2' });
  const fila = (t = {}) => {
    const d = el('input', { class: 'input', type: 'number', min: 1, value: t.desde_dias ?? '', placeholder: 'Desde días', 'aria-label': 'Desde cuántos días', style: 'max-width:9rem' });
    const p = el('input', { class: 'input', type: 'number', min: 0, step: '0.01', value: t.precio_dia ?? '', placeholder: 'Precio por día', 'aria-label': 'Precio por día', style: 'max-width:11rem' });
    const row = el('div', { class: 'flex gap-2 items-center wrap' }, el('span', { class: 'text-sm muted' }, 'Desde'), d,
      el('span', { class: 'text-sm muted' }, 'días:'), p, el('button', { class: 'btn ghost', type: 'button', onclick: () => row.remove() }, '✕'));
    row._leer = () => ({ desde_dias: d.value, precio_dia: p.value });
    filas.appendChild(row);
  };
  (datos.tarifas || []).forEach(fila);
  card.append(
    el('p', { class: 'text-sm muted' }, `Precio normal: ${fmtMoney(item.default_rental_price_per_day || 0)} por día. Agrega precios más bajos para rentas largas (por ejemplo, desde 7 días).`),
    filas,
    el('div', { class: 'flex gap-2 wrap mt-3' },
      el('button', { class: 'btn', type: 'button', onclick: () => fila() }, '+ Tarifa'),
      el('button', { class: 'btn primary', type: 'button', onclick: async () => {
        try {
          await Rentals.guardarTarifas(item.id, [...filas.children].map((r) => r._leer()).filter((t) => t.desde_dias && t.precio_dia !== ''));
          ok('Tarifas guardadas'); recargar();
        } catch (ex) { err(ex.message); }
      } }, 'Guardar tarifas')),
  );

  // Combo (kit)
  const esKit = el('input', { type: 'checkbox', id: 'eskit', checked: !!datos.es_kit });
  const comps = el('div', { class: 'flex-col gap-2 mt-3' });
  let catalogo = [];
  const comp = async (c = {}) => {
    if (!catalogo.length) catalogo = ((await Items.list({ limit: 1000 })).data || []).filter((i) => i.id !== item.id && !i.es_kit);
    const sel = el('select', { class: 'select', 'aria-label': 'Equipo del combo' },
      el('option', { value: '' }, '— Equipo —'), ...catalogo.map((i) => { const o = el('option', { value: i.id }, i.name); if (i.id === c.item_id) o.selected = true; return o; }));
    const q = el('input', { class: 'input', type: 'number', min: 1, value: c.cantidad || 1, 'aria-label': 'Cantidad', style: 'max-width:6rem' });
    const row = el('div', { class: 'flex gap-2 items-center' }, sel, q, el('button', { class: 'btn ghost', type: 'button', onclick: () => row.remove() }, '✕'));
    row._leer = () => ({ item_id: sel.value, cantidad: q.value });
    comps.appendChild(row);
  };
  for (const c of datos.componentes || []) await comp(c);
  card.append(
    el('div', { class: 'rp-sub' },
      el('label', { class: 'checkbox', for: 'eskit' }, esKit, el('span', {}, 'Es un combo: al rentarlo se apartan estos equipos')),
      comps,
      el('div', { class: 'flex gap-2 wrap mt-3' },
        el('button', { class: 'btn', type: 'button', onclick: () => comp() }, '+ Equipo del combo'),
        el('button', { class: 'btn primary', type: 'button', onclick: async () => {
          try {
            await Rentals.guardarKit(item.id, esKit.checked, [...comps.children].map((r) => r._leer()).filter((c) => c.item_id));
            ok('Combo guardado'); recargar();
          } catch (ex) { err(ex.message); }
        } }, 'Guardar combo'))),
  );
  return card;
}
